import { useCallback } from "react";
import { Grid, Divider, Typography } from "@material-ui/core";
import { Box, Button, List, ListItem } from "~/components/UI";
import Highlighter from "react-highlight-words";
import history from "~/packages/history";
import ROUTES from "~/constants/routes";
import { useTranslation } from "react-i18next";

interface ContractsResultProps {
  data?: Api.SearchResult<ContractsApi.ContractSearchResult>;
  searchQuery: string;
}

const Contract = ({
  contract,
  searchQuery,
}: {
  searchQuery: string;
  contract: ContractsApi.ContractSearchResult;
}) => {
  const openGroup = useCallback(() => {
    history.push(`${ROUTES.CONTRACTS}?contractId=${contract.id}`);
  }, [contract.id]);

  return (
    <ListItem button onClick={openGroup}>
      <Typography variant="body2" color="textSecondary">
        <Highlighter
          searchWords={[searchQuery]}
          textToHighlight={contract.contractName}
        />{" "}
        [
        <Typography variant="body2" component="span" color="primary">
          ID
        </Typography>
        :{" "}
        <Highlighter
          searchWords={[searchQuery]}
          textToHighlight={contract.id}
        />
        ]
      </Typography>
      <Divider />
    </ListItem>
  );
};

/**
 * @memberof GlobalSearch
 * @component
 * @desc Render of search results for the Contracts catalog.
 * @property {string} searchQuery - the text we are looking for
 * @property {Api.SearchResult<ContractsApi.ContractSearchResult>} data - api response
 */

const Contracts = ({ data, searchQuery }: ContractsResultProps) => {
  const { t } = useTranslation();

  const onShowAll = useCallback(() => {
    setTimeout(() => {
      history.push(`${ROUTES.CONTRACTS}?search=${searchQuery}`);
    }, 0);
  }, [searchQuery]);

  if (data && data.count) {
    return (
      <Box mb={4}>
        <Box py={4}>
          <Grid container alignItems="center">
            <Grid item sm>
              <Typography variant="subtitle1">
                {t("title.catalogContracts")} ({data.count})
              </Typography>
            </Grid>
            <Grid item>
              <Button variant="outlined" onClick={onShowAll}>
                {t("button.showAll")}
              </Button>
            </Grid>
          </Grid>
        </Box>
        <List>
          {data.data.map((u, index) => (
            <Contract key={index} searchQuery={searchQuery} contract={u} />
          ))}
        </List>
      </Box>
    );
  } else {
    return null;
  }
};

export default Contracts;
